/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import {Card, Col, Container, Row, Button} from 'reactstrap';
import {Link} from "react-router-dom";

/** Multiple Language imports **/
import {withLocalize} from "react-localize-redux";
import {renderToStaticMarkup} from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import {Translate} from "react-localize-redux";
import global from "../../translations/global.json"
/** End of Multiple Language imports **/
import LanguageManager from '../../custom-classes/language-manager';
import NavbarDesktop from './navbar-employee/navbar-desktop';
import NavbarMobile from './navbar-employee/navbar-mobile';
import Footer from '../footer/footer';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faDesktop, faHeadset, faMoneyCheck, faIdCardAlt, faEdit, faPrint, faRoad, faTags} from '@fortawesome/free-solid-svg-icons';
import ApiCalls from '../../custom-classes/api-calls';
import Switch from 'react-switch';
import DateFormater from '../../custom-classes/date-formater';
import ChartBar from '../charts/chart-bar';

/**
 * The dashboard of the employee
 */
class DashboardEmployee extends React.Component {

    constructor(props) {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        let languages = [
            {name: "English", code: "en"},
            {name: "Español", code: "es"}
        ];

        // To support language library add the following lines
        this.props.initialize({
            languages,
            options: {renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage()}
        });

        this.state = {
            subscriptionsData: null,
            navbarMobile: false,
            successfulRegistration: true,
            checked: false,
            triesChartData: null, // For table
            languages: languages,
        };
        this.props.addTranslation(global);
        this.checkIfChatAvailable = this.checkIfChatAvailable.bind(this);
        this.handleChangeChatToggle = this.handleChangeChatToggle.bind(this);
        this.handleSelectRoles = this.handleSelectRoles.bind(this);
    }

    /** Evaluate the resize, to show the proper navbar menu style*/
    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
        this.getLineChartData();
        // this.checkIfChatAvailable();
    }

    resize() {
        this.setState({navbarMobile: window.screen.width <= 1024});
    }

    handleSelectRoles(e){
     console.log(e);
    }

    /** toturn on or off the chat **/
    handleChangeChatToggle(){
        this.setState({checked: !this.state.checked},()=>{
            // This is promise
            let apiCall = ApiCalls.toggleChat(!this.state.checked);

            // After the api call, fill the data
            apiCall.then((data)=> {
                this.setState({checked: !data.IsChatTurnedOn });
            });
        })
    }

    /**
     * Check if the chat is available or not
     */
    checkIfChatAvailable(){
        // This is promise
        let apiCall = ApiCalls.getChatStatus();
        // After the api call, fill the data
        apiCall.then((data)=> {
            this.setState({checked: !data.IsChatTurnedOn});
        });
    }

    /**
     * Returns the main chart data
     */
    getLineChartData(){

        let now = new Date();
        let dateAgo = new Date();
        dateAgo.setMonth(dateAgo.getMonth() - 3);

        let apiCall =
            ApiCalls.getReportSubscription(null,
                DateFormater.formatDate(dateAgo), DateFormater.formatDate(now));
        apiCall.then((data)=> {
            let cancelations = LanguageManager.getTranslation("dashboard-employee.subscriptions-cancelled", this.state.languages);// LanguageManager.getTranslation("dashboard-employee.subscriptions-cancelled", this.state.languages);
            let actives = LanguageManager.getTranslation("dashboard-employee.subscriptions-active", this.state.languages); //"Active"; //LanguageManager.getTranslation("dashboard-employee.subscriptions-active", this.state.languages);
            let trialing = LanguageManager.getTranslation("dashboard-employee.subscriptions-trialing", this.state.languages);

            // Do the API call
            var chartLineData = {
                labels: [LanguageManager.getTranslation("dashboard-employee.subscriptions", this.state.languages)],
                datasets: [
                    {
                        label: actives,
                        fillColor: 'rgba(51,255,153,1)',
                        strokeColor: 'rgba(51,255,153,1)',
                        pointColor: 'rgba(51,255,153,1)',
                        pointStrokeColor: '#fff',
                        pointHighlightFill: '#fff',
                        pointHighlightStroke: 'rgba(51,255,153,1)',
                        data: [data.TotalActive],
                    },
                    {
                        label: trialing,
                        fillColor: 'rgba(255,255,51,1)',
                        strokeColor: 'rgba(255,255,51,1)',
                        pointColor: 'rgba(255,255,51,1)',
                        pointStrokeColor: '#fff',
                        pointHighlightFill: '#fff',
                        pointHighlightStroke: 'rgba(255,255,51,1)',
                        data: [data.TotalTrialing],
                    },
                    {
                        label: cancelations,
                        fillColor: 'rgba(255,102,102,1)',
                        strokeColor: 'rgba(255,102,102,1)',
                        pointColor: 'rgba(255,102,102,1)',
                        pointStrokeColor: '#fff',
                        pointHighlightFill: '#fff',
                        pointHighlightStroke: 'rgba(255,102,102,1)',
                        data: data.TotalCanceled,
                    }
                ]
            };
            this.setState({
                triesChartData: chartLineData
            });
        });
    }

    /**
     * Renders the main dashboard
     * @returns {XML}
     */
    render() {
        return (
            <div>
                {this.state.navbarMobile ? <NavbarMobile/> : <NavbarDesktop/>}
                <div className="container-padding">
                    <Container className={this.state.navbarMobile ? "margin-top-mandatory-60" : null}>
                        <h2 className="font-now-bold white-text">
                            <FontAwesomeIcon icon={faDesktop}/>{' '}
                            <Translate id="dashboard.home" options={{renderInnerHtml: true}}/>
                        </h2>
                        <hr/>
                        <Row>
                            <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                <h4 className="font-now-bold white-text">
                                    <Translate id="dashboard-employee.subscriptions-last-three-months"
                                               options={{renderInnerHtml: true}}/>
                                </h4>
                            </Col>
                            <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                <Card body className="text-center card-cyan">
                                    {
                                        typeof this.state.triesChartData !== 'undefined' && this.state.triesChartData !== null ?
                                            <ChartBar data={this.state} /> : null
                                    }
                                </Card>
                            </Col>

                            <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                <Row>
                                    <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                        <hr/>
                                        <h4 className="font-now-bold white-text">
                                        <FontAwesomeIcon icon={faRoad}/>{' '}
                                            <Translate id="dashboard-employee.shortcuts" options={{renderInnerHtml: true}}/>
                                        </h4>
                                    </Col>
                                    <Col lg={{size: 6}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                            <Card body className="card-red">
                                                <Row>
                                                    <Col lg={{size: 2}} md={{size: 2}} sm={{size: 2}} xs={{size: 2}}>
                                                        <FontAwesomeIcon icon={faIdCardAlt} size="2x"/>{' '}
                                                    </Col>
                                                    <Col lg={{size: 10}} md={{size: 10}} sm={{size: 10}} xs={{size: 10}}>
                                                        <span className="font-now-bold">
                                                            <Translate id="dashboard-employee.subscriptions-add-private"/>
                                                        </span>
                                                        <br/>
                                                        <small>
                                                            <Translate id="dashboard-employee.subscriptions-add-private-instructions"/>
                                                        </small>
                                                        <hr/>
                                                        <Link className="btn btn-outline-light" to="/subscription-manager">
                                                            <Translate id="dashboard-employee.add-new" options={{renderInnerHtml: true}}/>
                                                        </Link>
                                                    </Col>
                                                </Row>
                                            </Card>
                                    </Col>
                                    <Col lg={{size: 6}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                        <Card body className="card-dark-blue">
                                            <Row>
                                                <Col lg={{size: 2}} md={{size: 2}} sm={{size: 2}} xs={{size: 2}}>
                                                    <FontAwesomeIcon icon={faTags} size="2x"/>{'   '}
                                                </Col>
                                                <Col lg={{size: 10}} md={{size: 10}} sm={{size: 10}} xs={{size: 10}}>
                                                     <span className="font-now-bold">
                                                         <Translate id="dashboard-employee.coupons"/>
                                                     </span>
                                                    <br/>
                                                    <small><Translate id="dashboard-employee.coupons-instruction"/></small>
                                                    <hr/>
                                                    <Link to="/coupons" className="btn btn-outline-light">
                                                        <Translate id="dashboard-employee.go" options={{renderInnerHtml: true}}/>
                                                    </Link>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>

                            {/* <Col lg={{size: 4}} md={{size: 5}} sm={{size: 12}} xs={{size: 12}}>
                                <Card body className="card-blue">
                                    <Row>
                                        <Col lg={{size: 2}} md={{size: 2}} sm={{size: 2}} xs={{size: 2}}>
                                            <FontAwesomeIcon icon={faHeadset} size="2x"/>{' '}
                                        </Col>
                                        <Col lg={{size: 10}} md={{size: 10}} sm={{size: 10}} xs={{size: 10}}>
                                            <span className="font-now-bold">
                                                  <Translate id="chat.chat-toggle" options={{renderInnerHtml: true}}/>
                                            </span>
                                            <br/>
                                            <small>
                                                <Translate id="chat.chat-toggle-instructions" options={{renderInnerHtml: true}}/>
                                            </small>
                                            <hr/>
                                            <Switch
                                                onChange={this.handleChangeChatToggle}
                                                checked={!this.state.checked}  offColor="#f44256"
                                                id="normal-switch"
                                            />
                                            <p/>
                                            <Link className="btn btn-outline-light" to="/chatroom">
                                                <Translate id="dashboard-employee.go-to-chatroom" options={{renderInnerHtml: true}}/>
                                            </Link>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col> */}
                        </Row>
                        <Row>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <Card body className="card-green">
                                    <Row>
                                        <Col lg={{size: 2}} md={{size: 2}} sm={{size: 2}} xs={{size: 2}}>
                                            <FontAwesomeIcon icon={faMoneyCheck} size="2x"/>{' '}
                                        </Col>
                                        <Col lg={{size: 10}} md={{size: 10}} sm={{size: 10}} xs={{size: 10}}>
                                            <span className="font-now-bold">
                                                  <Translate id="dashboard-employee.plans" options={{renderInnerHtml: true}}/>
                                            </span>
                                            <br/>
                                            <small>
                                                <Translate id="dashboard-employee.plans-instructions" options={{renderInnerHtml: true}}/>
                                            </small>
                                            <hr/>
                                            <p/>
                                            <Link className="btn btn-outline-light" to="/plans-manager">
                                                <Translate id="dashboard-employee.add-new" options={{renderInnerHtml: true}}/>
                                            </Link>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <Card body className="card-orange">
                                    <Row>
                                        <Col lg={{size: 2}} md={{size: 2}} sm={{size: 2}} xs={{size: 2}}>
                                            <FontAwesomeIcon icon={faPrint} size="2x"/>{' '}
                                        </Col>
                                        <Col lg={{size: 10}} md={{size: 10}} sm={{size: 10}} xs={{size: 10}}>
                                            <span className="font-now-bold">
                                                  <Translate id="dashboard-employee.reports"
                                                             options={{renderInnerHtml: true}}/>
                                            </span>
                                            <br/>
                                            <small>
                                                <Translate id="dashboard-employee.reports-instructions"
                                                           options={{renderInnerHtml: true}}/>
                                            </small>
                                            <hr/>
                                            <p/>
                                            <Link className="btn btn-outline-light" to="/reports">
                                                <Translate id="dashboard-employee.go"
                                                           options={{renderInnerHtml: true}}/>
                                            </Link>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Footer/>
            </div>

        )
    };
}

export default withLocalize(DashboardEmployee);